const lang = {
  resetPassword: 'パスワード再設定',
  resetPasswordHint: 'ZENGOに登録しているメールアドレスを入力し、【送信する】を押すと、パスワードを再設定用メールが届きます。メールに記載URLよりパスワードを再設定してください。',
  emailAddress: 'メールアドレス',
  emailAddressConfirm: 'メールアドレス（確認用）',
  message: 'ご入力いただいたメールアドレスに間違いがないかご確認のうえ、【送信する】を押してください。',
  sent: '送信しました',
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/forgotPassword.js